import { groups } from '~/helpers/groups';
import { slugify } from '~/helpers/slugify';
import type { Checkin } from '~/types';

export type UrlGroup =
  | 'checkin'
  | 'cafe'
  | 'roaster'
  | 'region'
  | 'country'
  | 'producer'
  | 'location/city'
  | 'location/state'
  | 'location/country'
  | 'processing-method'
  | 'brewing-method'
  | 'varietal';

export const getUrl = ({ checkin, group, externalVenueLink }: { checkin: Checkin, group: UrlGroup, externalVenueLink?: boolean }): string | undefined => {
  if (group === 'checkin') return `/checkin/${slugify(checkin.id)}`;

  const hasGroup = groups.some((obj) => {
    if (obj.group === group) return true;
    if ('pathPrefix' in obj && obj.pathPrefix === group) return true;
    return false;
  });

  if (!hasGroup) return undefined;

  switch (group) {
    case 'cafe':
      // NOTE: This venue.url is currently not populated due to an API change by Foursquare
      // To get venue.url, we may have to make an API request to venue/:id and get the data there..
      if (externalVenueLink) {
        return checkin.venue?.url || `https://foursquare.com/v/${checkin.venue?.id}`;
      }

      return `/cafe/${slugify(checkin.venue?.name || '')}`;

    case 'roaster':
      return `/roaster/${slugify(checkin.roaster || '')}`;

    case 'region':
      return `/region/${slugify(checkin.area || '')}`;

    case 'country':
      return `/country/${slugify(checkin.country || '')}`;

    case 'producer':
      return `/producer/${slugify(checkin.producer || '')}`;

    case 'location/city':
      return `/location/city/${slugify(checkin.venue?.location?.city || '')}`;

    case 'location/state':
      return `/location/state/${slugify(checkin.venue?.location?.state || '')}`;

    case 'location/country':
      return `/location/country/${slugify(checkin.venue?.location?.country || '')}`;

    case 'processing-method':
      return `/processing-method/${slugify(checkin.processingMethod || '')}`;

    case 'brewing-method':
      return `/brewing-method/${slugify(checkin.brewingMethod || '')}`;

    case 'varietal':
      return `/varietal/${slugify(checkin.varietal || '')}`;

    default:
      throw new Error(`Bad getUrl call with group=${group}.`);
  }
};
